<template>
  <b-navbar toggleable="sm" variant="light">
    <b-navbar-brand>FMSched</b-navbar-brand>
    <b-navbar-toggle target="view-selection"></b-navbar-toggle>
    <b-collapse is-nav id="view-selection">
      <b-navbar-nav>
        <b-nav-item :to="{name: 'masterdetailempty'}" active-class="active">Master Detail</b-nav-item>
        <b-nav-item :to="{name: 'newspaper'}" active-class="active">Newspaper</b-nav-item>
        <b-nav-item :to="{name: 'grid'}" active-class="active">Grid</b-nav-item>
        <b-nav-item :to="{name: 'weekly'}" active-class="active">Weekly</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right @shown="markRead">
          <template v-slot:button-content>
            Notifications
            <b-badge v-if="hasNotification" variant="danger">{{notificationCount}}</b-badge>
          </template>
          <b-dropdown-text
            v-for="notification in notifications"
            :key="notification.receivedISO"
            :variant="notification.variant"
          >
            <span>{{notification.receivedMinute}}</span>
            {{ }}
            <span>{{notification.message}}</span>
          </b-dropdown-text>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  computed: {
    notifications: vm => vm.$store.state.notification.notifications,
    notificationCount: vm => vm.$store.getters["notification/unread"].length,
    hasNotification: vm => vm.notificationCount > 0
  },
  methods: {
    markRead() {
      this.$store.dispatch("notification/markRead");
    }
  }
};
</script>